import * as types from "../ActionType";

const initState = {
    AllPackages: [],
    loadingAllPackages: true,
    Features: [],
    loadingFeatures: true
}

const PackagesReducer = (state = initState, action) => {
    switch (action.type) {
        case types.GET_ALL_PACKAGES:
            return { ...state, AllPackages: action.payload, loadingAllPackages: false }
        case types.ADD_PACKAGE:
            return { ...state, loadingAllPackages: true }
        case types.EDIT_PACKAGE:
            return { ...state, loadingAllPackages: true }
        case types.DELETE_PACKAGE:
            return { ...state, loadingAllPackages: true }
        case types.EDIT_STATUS_PACKAGE:
            return { ...state, loadingAllPackages: true }
        case types.ADD_FEATURES:
            return { ...state }
        case types.GET_FEATURES:
            return { ...state, Features: action.payload, loadingFeatures: false }
        case types.EMPTY_FEATURES:
            return { ...state, Features: action.payload, loadingFeatures: true }
        case types.ADD_TO_VENDOR:
            return { ...state }
        case types.ADD_FEATURE_TO_VENDOR:
            return { ...state }
        default:
            return state;
    }
};

export default PackagesReducer;
